import {
	ChangeDetectorRef,
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
} from '@angular/core'
import { Package } from '../../models/package.model'
import { Subscription } from 'rxjs'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { TranslateService } from '@ngx-translate/core'

@Component({
	selector: 'app-add-package-duration',
	templateUrl: './add-package-duration.component.html',
	styleUrls: ['./add-package-duration.component.scss'],
})
export class AddPackageDurationComponent implements OnInit {
	@Input() packageData!: Package
	@Input() isEditMode!: boolean
	viewMode: boolean = true
	isChanged = false
	oldValues = null
	@Output() emitData = new EventEmitter()
	subscription = new Subscription()
	packageForm: FormGroup = new FormGroup({})
	today = new Date()
	formError = false
	constructor(
		public translate: TranslateService,
		private cd: ChangeDetectorRef
	) {}

	ngOnInit(): void {}

	ngOnChanges(): void {
		this.initForm()
	}

	initForm() {
		this.packageForm = new FormGroup({
			startDate: new FormControl(
				{
					value: this.packageData?.startDate,
					disabled: this.packageData?.hasBooking ? true : false,
				},
				[Validators.required]
			),
			endDate: new FormControl(this.packageData?.endDate),
		})
		if (!this.isEditMode)
			this.packageForm.valueChanges.subscribe((res) => {
				this.onSave()
			})
	}

	onSave(isSave?: boolean) {
		this.emitData.emit({
			value: this.packageForm.getRawValue(),
			isValid: this.packageForm.valid,
			isSave: isSave,
			index: 1,
		})
	}

	getController(controlName: string) {
		return this.packageForm.controls[controlName]
	}
}
